import { productFruits } from 'product-fruits'
import type { UserData } from '~/stores/user'
import { useRuntimeConfig, useNuxtApp } from '#app'
import { useRouter } from '#vue-router'
import { useLogger } from '#layers/base/composables/useLogger'
import { useCountryConfig } from '~/composables/useCountryConfig'

export default defineNuxtPlugin(() => {
  const workspaceCode = useCountryConfig().productFruitsCode
  const { productFruitsEnabled } = useRuntimeConfig().public
  const router = useRouter()
  const locale = useNuxtApp().$i18n.locale
  const log = useLogger()

  if (!productFruitsEnabled || !workspaceCode)
    return

  let isInitialized = false

  const initProductFruits = (user: UserData | null | undefined) => {
    if (!user || isInitialized || !workspaceCode)
      return
    log.trace('Init product-fruits', { user: user.email })

    isInitialized = true

    productFruits.init(
      workspaceCode,
      locale.value,
      {
        username: user.email,
        email: user.email,
        firstname: user.firstname,
        lastname: user.lastname,
        signUpAt: new Date(user.dateCreated ?? new Date(2018, 0)).toISOString(),
      },
      { disableLocationChangeDetection: true },
    )

    router.afterEach(() => {
      productFruits.safeExec(($productFruits) => {
        $productFruits.push(['pageChanged'])
      })
    })
  }

  watch(
    () => useUserStore().data,
    user => initProductFruits(user),
    { immediate: true },
  )
})
